import React from 'react'
import { Formik, Form as FormikForm, Field as FormikField } from 'formik'

import CsgButton from 'components/atoms/Button'
import CsgCard from 'components/molecules/Card'
import CsgTypography from 'components/atoms/Typography'
import CsgInputField from 'components/atoms/InputField'

import MuiGrid from '@material-ui/core/Grid'
import MuiTooltip from '@material-ui/core/Tooltip'
import MuiIconButton from '@material-ui/core/IconButton'

import theme from 'app/theme'
import styled from 'styled-components'

const ModalContentContainer = styled(CsgCard)`
  && {
    padding: 16px;
    width: 100%;
  }
`

const CharacterCounter = styled(CsgTypography)`
  && {
    width: 100%;
    text-align: end;
    font-size: 0.875rem;
    padding-right: 8px;
  }
`

const EmojiContainer = styled(MuiGrid)`
  && {
    padding-bottom: 4px;
  }
`

const EmojiButton = styled(({ ...props }) => <MuiIconButton {...props} />)`
  && {
    font-size: 32px;
    padding: 8px;
    color: ${props => (props.active ? 'unset' : theme.palette.text.hint)};
  }
`

const WidgetFeedbackRatingForm = ({
  t,
  rows,
  rowsMax,
  multiline,
  characterLimit,
  handleRatingMessage,
  validationSchema,
  initialValues,
  onFormSubmit,
  onRatingEmoji,
  selectedEmoji,
  emojiList
}) => {
  return (
    <ModalContentContainer container direction="column" xs={12}>
      <Formik
        enableReinitialize
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={onFormSubmit}
      >
        {({ isSubmitting, values, setValues }) => (
          <FormikForm noValidate>
            <EmojiContainer
              container
              item
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="space-around"
            >
              {emojiList.map(({ emoji, value, label }) => {
                return (
                  <MuiTooltip key={value} title={label}>
                    <EmojiButton
                      disabled={isSubmitting}
                      active={selectedEmoji === value}
                      onClick={() => onRatingEmoji(value)}
                    >
                      {emoji}
                    </EmojiButton>
                  </MuiTooltip>
                )
              })}
            </EmojiContainer>

            <MuiGrid container direction="column" xs={12} noWrap>
              <MuiGrid container item spacing={2} direction="row" alignItems="center">
                <MuiGrid item xs={12}>
                  <FormikField
                    disabled={isSubmitting}
                    id="input-avaliacao"
                    value={values.ratingMessage}
                    name="ratingMessage"
                    label={t('widget_feedback_rating_popover_form_input_label')}
                    onChange={event => handleRatingMessage('avaliacao', event.target.value, setValues)}
                    rows={rows}
                    rowsMax={rowsMax}
                    multiline={multiline}
                    component={CsgInputField}
                    placeholder={t('widget_feedback_rating_popover_form_input_placeholder')}
                  />
                  {characterLimit && (
                    <CharacterCounter>
                      {t('global_min_caracteres', {
                        caracteres: values.avaliacao ? values.avaliacao.length : 0,
                        minValue: characterLimit
                      })}
                    </CharacterCounter>
                  )}
                </MuiGrid>
              </MuiGrid>

              <CsgButton
                id="btn-enviar"
                disabled={isSubmitting || !selectedEmoji}
                type="submit"
                color="primary"
                variant="contained"
                style={{ marginTop: '12px' }}
              >
                {t('global_send')}
              </CsgButton>
            </MuiGrid>
          </FormikForm>
        )}
      </Formik>
    </ModalContentContainer>
  )
}

export default WidgetFeedbackRatingForm
